/** Session hints for onboarding navigation (see main.js router + WelcomePage). */

export var SK_ONBOARDING_PIPELINE_DONE = 'sk_onboarding_pipeline_done'
export var SK_ONBOARDING_CONNECT_DEFERRED = 'sk_onboarding_connect_deferred'

export function readPipelineDoneHint () {
  try {
    return sessionStorage.getItem(SK_ONBOARDING_PIPELINE_DONE) === '1'
  } catch (e) {
    return false
  }
}

export function readConnectDeferredHint () {
  try {
    return sessionStorage.getItem(SK_ONBOARDING_CONNECT_DEFERRED) === '1'
  } catch (e) {
    return false
  }
}

export function setPipelineDoneHint () {
  try {
    sessionStorage.setItem(SK_ONBOARDING_PIPELINE_DONE, '1')
  } catch (e) {}
}

export function setConnectDeferredHint () {
  try {
    sessionStorage.setItem(SK_ONBOARDING_CONNECT_DEFERRED, '1')
  } catch (e) {}
}

export function clearConnectDeferredHint () {
  try {
    sessionStorage.removeItem(SK_ONBOARDING_CONNECT_DEFERRED)
  } catch (e) {}
}

export function clearPipelineDoneHint () {
  try {
    sessionStorage.removeItem(SK_ONBOARDING_PIPELINE_DONE)
  } catch (e) {}
}

export function clearOnboardingSessionHints () {
  try {
    sessionStorage.removeItem(SK_ONBOARDING_PIPELINE_DONE)
    sessionStorage.removeItem(SK_ONBOARDING_CONNECT_DEFERRED)
  } catch (e) {}
}



// WEBPACK FOOTER //
// ./src/utils/onboardingSessionHints.js